import React from "react";
import { FaSearch } from "react-icons/fa";
import { Tooltip } from "@mui/material";

export function CodeBookHeader({
  activeIcon,
  codeBookLoading,
  getIcon,
  getTooltipTitle,
  onIconClick,
  showReferencesDropdown,
  onToggleReferences,
  onReferenceSelect,
  hasNavigationHistory,
  onBack,
  selectedCodebookVersion,
  onVersionChange,
}) {
  const referenceItems = [
    ["morphology", "Morphology"],
    ["nationalCoding", "National Coding Advice"],
    ["StateAdvice-NSW", "State Advice - NSW"],
    ["StateAdvice-VIC", "State Advice - VIC"],
    ["StateAdvice-QLD", "State Advice - QLD"],
  ];

  return (
    <div className="codebook1-header">
      {["ICD", "Tabular", "Coding"].map((icon) => (
        <span
          key={icon}
          className={`header-navicon ${activeIcon === icon ? "active-icon" : ""}`}
          onClick={() => onIconClick(icon)}
        >
          <Tooltip title={getTooltipTitle(icon)}>
            <span>
              <img src={getIcon(icon)} alt={`${icon} Icon`} width={30} height={30} />
            </span>
          </Tooltip>
        </span>
      ))}

      <span
        className={`header-navicon ${activeIcon === "References" ? "active-icon" : ""} ${codeBookLoading ? "disabled-icon" : ""}`}
        onClick={() => {
          if (!codeBookLoading) onToggleReferences();
        }}
        style={{
          pointerEvents: codeBookLoading ? "none" : "auto",
          opacity: codeBookLoading ? 0.5 : 1,
          cursor: codeBookLoading ? "not-allowed" : "pointer",
        }}
      >
        <img src={getIcon("References")} alt="Coding Icon" width={20} height={20} />
      </span>

      {showReferencesDropdown && (
        <div className="references-dropdown">
          {referenceItems.map(([reference, label]) => (
            <div
              key={reference}
              className="dropdown-item"
              onClick={() => onReferenceSelect(reference)}
            >
              {label}
            </div>
          ))}
        </div>
      )}

      <Tooltip title="Back">
        {hasNavigationHistory && (
          <button
            type="button"
            className="codebook-back-btn"
            onClick={onBack}
            title="Back"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M15 18l-6-6 6-6"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        )}
      </Tooltip>

      <span style={{ marginLeft: "auto" }}>
        <select
          className="codebook-version-select"
          value={selectedCodebookVersion}
          onChange={onVersionChange}
        >
          <option value="12th">12th</option>
          <option value="13th">13th</option>
        </select>
      </span>
    </div>
  );
}

export function CodeBookTabs({ activeIcon, activeTab, onTabChange }) {
  return (
    <div className="tabs-codes">
      {activeIcon === "ICD" && (
        <>
          <button
            className={activeTab === "ICD 10 AM Index" ? "active" : ""}
            style={{
              borderBottomColor:
                activeTab === "ICD 10 AM Index" ? "#FFE404" : "transparent",
            }}
            onClick={() => onTabChange("ICD 10 AM Index")}
          >
            ICD 10 AM Index
          </button>
          <button
            className={activeTab === "ACHI Index" ? "active" : ""}
            style={{
              borderBottomColor:
                activeTab === "ACHI Index" ? "green" : "transparent",
            }}
            onClick={() => onTabChange("ACHI Index")}
          >
            ACHI Index
          </button>
        </>
      )}
      {activeIcon === "Tabular" && (
        <>
          <button
            className={activeTab === "ICD 10 AM Tabular" ? "active" : ""}
            style={{
              borderBottomColor:
                activeTab === "ICD 10 AM Tabular" ? "red" : "transparent",
            }}
            onClick={() => onTabChange("ICD 10 AM Tabular")}
          >
            ICD 10 AM Tabular
          </button>
          <button
            className={activeTab === "ACHI Tabular" ? "active" : ""}
            style={{
              borderBottomColor:
                activeTab === "ACHI Tabular" ? "blue" : "transparent",
            }}
            onClick={() => onTabChange("ACHI Tabular")}
          >
            ACHI Tabular
          </button>
        </>
      )}
      {activeIcon === "Coding" && (
        <button
          className={activeTab === "Australian Coding Standard" ? "active" : ""}
          style={{ borderBottomColor: "purple" }}
        >
          Australian Coding Standards (ACS)
        </button>
      )}
      {activeIcon === "References" && (
        <button
          className={activeTab === "National Coding Advice" ? "active" : ""}
          style={{ borderBottomColor: "blue" }}
        >
          Additional References
        </button>
      )}
    </div>
  );
}

export function CodeBookSearchField({ value, onChange }) {
  return (
    <div className="search-bar-code">
      <FaSearch className="codebook-search-icon" />
      <input
        type="text"
        className="search-input"
        placeholder="Search by code or description"
        value={value}
        onChange={onChange}
      />
    </div>
  );
}
